import React from 'react';

const Statut = () => {
    return (
        <div className="pt-24 pb-20 bg-gray-100 dark:bg-gray-900">
            <div className="container mx-auto px-4 max-w-4xl">
                <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-8 md:p-12 ring-1 ring-gray-100 dark:ring-white/10">
                    <h1 className="text-3xl md:text-4xl font-extrabold mb-8 text-gray-900 dark:text-white border-b pb-4 border-gray-200 dark:border-gray-700">
                        Statut Fundacji Absolwentów Informatyki Uniwersytetu Wrocławskiego
                    </h1>

                    <div className="space-y-8 text-gray-700 dark:text-gray-300 leading-relaxed">
                        <section>
                            <h2 className="text-xl font-bold mb-4 text-gray-900 dark:text-white flex items-center">
                                <span className="bg-blue-100 text-blue-800 text-xs font-bold px-2.5 py-0.5 rounded mr-2 dark:bg-blue-900 dark:text-blue-300">§1</span>
                                Cele Fundacji
                            </h2>
                            <p className="mb-4">Celami fundacji jest działalność w zakresie:</p>
                            <ol className="list-decimal pl-6 space-y-2 marker:text-blue-600">
                                <li>Działanie na rzecz nauki poprzez rozpowszechnianie wiedzy i kultury informatycznej.</li>
                                <li>Prowadzenie działalności edukacyjno-oświatowej i naukowo-badawczej w zakresie informatyki.</li>
                                <li>Wspieranie kształcenia zawodowego kadr informatycznych.</li>
                            </ol>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold mb-4 text-gray-900 dark:text-white flex items-center">
                                <span className="bg-blue-100 text-blue-800 text-xs font-bold px-2.5 py-0.5 rounded mr-2 dark:bg-blue-900 dark:text-blue-300">§2</span>
                                Realizacja celów
                            </h2>
                            <p className="mb-4">Realizacja ww. celów następuje poprzez:</p>
                            <ol className="list-decimal pl-6 space-y-2 marker:text-blue-600">
                                <li>Prowadzenie działalności oświatowej i naukowej.</li>
                                <li>Prowadzenie oraz organizowanie kursów i obozów naukowych dla dzieci i młodzieży.</li>
                                <li>Organizowanie konkursów i olimpiad.</li>
                                <li>Realizację projektów edukacyjnych.</li>
                                <li>Realizację projektów naukowych, w szczególności międzyuczelnianych i interdyscyplinarnych.</li>
                                <li>Prowadzenie działalności szkoleniowej i informacyjno-doradczej.</li>
                                <li>Udzielanie wsparcia finansowego, rzeczowego i organizacyjnego przedsięwzięciom służącym osiągnięciu celów Fundacji.</li>
                                <li>Współpracę z jednostkami naukowymi, organami samorządu terytorialnego, instytucjami publicznymi, przedsiębiorcami oraz innymi organizacjami pozarządowymi w zakresie realizacji celów Fundacji.</li>
                                <li>Przyznawanie stypendiów i grantów naukowych w celu doskonalenia specjalistycznych umiejętności w dzidzinach zgodnych z celami Fundacji.</li>
                                <li>Organizowanie działań służących podnoszeniu kwalifikacji kadry nauczycielskiej, w zakresie zgodnym z celami Fundacji.</li>
                                <li>Zakup pomocy dydaktycznych (w szczególności książek) dla uzdolnionych dzieci i młodzieży z rodzin o niskich dochodach.</li>
                                <li>Udzielanie dopłat do udziału w obozach i warsztatach naukowych.</li>
                            </ol>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Statut;
